import React, {useLayoutEffect, useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';

import RightHeader from '../../generals-components/headers/right-header';
import AccountSettingsPageMain from './components/main';
import Footer from '../../generals-components/footer/footer';

import AccountSettingsLoading from './components/loading'

async function checkUserSession() {
    const response = await fetch('/api/check-token', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        return true;
    } else {
        return false;
    }
}

async function getUserNotifications() {  
    if (document.hidden) return;

    const response = await fetch('/api/get-account-notifications', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    const data = await response.json();

    if (response.ok) {
        return data;
    } else {
        return false;
    }
}

async function getUserData() {
    const response = await fetch('/api/get-account-data', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        const user_data = await response.json();
        console.log(user_data)
        return user_data;
    } else {
        return false;
    }
}

function AccountSettingPage() {
    const navigate = useNavigate();
    const [userNotifications, setUserNotifications] = useState(false)
    const [userData, setUserData] = useState({})
    const [isReady, setIsReady] = useState(false)

    const getAndSetUserNotifications = async () => {
        setUserNotifications(await getUserNotifications())
    };

    const getAndSetUserData = async () => {
        setUserData(await getUserData())
    };

    useLayoutEffect(() => {
        const startDashboard = async () => {
            if (!await checkUserSession()) {
                navigate('/login');
                return
            }

            await getAndSetUserNotifications()
            await getAndSetUserData()
        };

        startDashboard();
        
    }, [navigate])

    useEffect(() => {
        const interval = setInterval(async () => {
            await getAndSetUserNotifications();
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (Object.keys(userData).length !== 0) {
            setIsReady(true)
        }
    }, [userData])

    if (!isReady) {
        return (
            <AccountSettingsLoading/>
        )
    } 

    return (
        <div className="relative flex h-auto min-h-screen w-full flex-col group/design-root">
            <div className="layout-container flex h-full grow flex-col">
                <RightHeader userNotifications={userNotifications} currentPage={"Settings"}/>

                <AccountSettingsPageMain userData={userData}/>

                <Footer currentPage={"Account Settings"}/>
            </div>
        </div>
    );
}

export default AccountSettingPage;